import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
export const updateRole = async ({ roleId, payload }) => {
  const { data } = await authApiClient.put(`/roles/${roleId}`, payload);
  return data;
};

export const useUpdateRoleHandler = ({ onSuccess } = {}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { settings } = useTranslatedMessages();
  const teamSnacks = settings.team?.snackbar ?? {};

  const mutation = useMutation({
    mutationFn: updateRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['auth-roles'] });
      dispatch(
        showSnackbar({
          message: teamSnacks.role_updated || 'Role updated successfully',
          severity: 'success',
        }),
      );
      onSuccess?.();
    },
    onError: (error) => {
      const message =
        error instanceof AxiosError
          ? error.response?.data?.errors?.message || error.message
          : teamSnacks.role_update_error || 'Failed to update role';
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
